<template>
    <span>
    <s-button v-if="zones!=null" 
                :icon="icon" 
                :theme="theme"
                :label="showDispo || theme != null ? terrain : 'en attente'"
                :role="role"
                :afterIcon="afterIcon"
                @onclick="$emit('onclick')"
    /> 
    </span>    
</template>
<script>
export default ({
    props: ["zones", "terrain", "zone", "role", "indexPartie", "showDispo", "equipe", "parties"],
    computed: {
       icon() {
        var icon='';
        var bool = false;
        if (this.terrain!=null &&  (this.showDispo || this.theme!=null)) {
            var joueurs=[];
            for (var joueur in this.equipe.joueurs) {
                if (this.equipe.joueurs[joueur]!=null) {
                    joueurs.push(this.equipe.joueurs[joueur].numero);
                }
            }
            for (var joueur in this.equipe.contre) {
                if (this.equipe.contre[joueur]!=null) {
                    joueurs.push(this.equipe.contre[joueur].numero);
                }
            }
            if (typeof(this.zones[this.zone])!="undefined") {
                var terrain =  this.zones[this.zone].terrains[this.terrain];
                terrain.parties.forEach((partie2, indexPartie2)=>{
                if (partie2!=null) {
                        if (typeof(partie2.joueurs)!="undefined") {
                            if (this.indexPartie != indexPartie2 && !bool) {
                                partie2.joueurs.forEach(joueur2=>{
                                    if (!bool)
                                        bool =  joueurs.findIndex(joueur=>joueur==joueur2)!=-1;
                                })
                            }
                        }
                    }
                })        
            } 
            if (bool)
                icon='street-view'
        }
        return icon;
       },
       afterIcon() {
           var icon='';
            if (this.terrain!=null &&  (this.showDispo || this.theme!=null)) {
                if (typeof(this.zones[this.zone])!="undefined") {
                    var terrain =  this.zones[this.zone].terrains[this.terrain];
                
                    if (typeof(terrain.parties)!="undefined") {
                            var bool = false;
                            terrain.parties.forEach((partie, indexPartie)=>{
                                if (this.parties[indexPartie]!="undefined" && !bool) 
                                    if (    partie!=null && 
                                            indexPartie!=this.indexPartie && 
                                            this.parties[indexPartie].state=="INPROGRESS")
                                    bool = partie.state == "BUSY";
                            })
                            
                            icon = bool ? 'exclamation' : '';
                    }
                }
            }
            return icon;
        },
        theme() {
            var theme=null;
            if (this.terrain!=null) {
                if (typeof(this.zones[this.zone])!="undefined") {
                    var terrain =  this.zones[this.zone].terrains[this.terrain];
                    if (terrain.disponible) {
                        if (typeof(terrain.parties)!="undefined") {
                            if (terrain.parties[this.indexPartie]!=null) {
                                var stateTerrain = terrain.parties[this.indexPartie].state;
                                
                                if (stateTerrain == "EMPTY") {
                                    theme="";
                                }
                                else if (stateTerrain == "BUSY") {
                                    theme = 'is-dark';
                                }
                                else if (stateTerrain == "SOON")
                                    theme = 'is-warning';
                                else {/*
                                    var bool = false;
                                    terrain.parties.forEach((partie, indexPartie)=>{
                                        if (partie!=null && indexPartie!=this.indexPartie) {
                                            bool = partie.state == 'BUSY'
                                        }
                                    })
                                    if (bool)
                                        return 'is-info';*/
                                }
                            }
                        }
                    }
                    else {
                        return 'is-danger'
                    }
                }
                else {
                    return 'is-danger'
                }
            }
            return theme;
        }
    },
})
</script>
